import React, { createContext, useContext, useState } from 'react';

// Sistema de idioma: el usuario elige ES/EN (selector en el menú lateral).
// Las claves no traducidas devuelven el texto en español por defecto.
const DICT = {
  es: {
    dashboard: 'Dashboard', bots: 'Bots', trading: 'Trading', arbitrage: 'Arbitraje',
    news: 'Noticias', live: 'En Vivo', settings: 'Configuración', admin: 'Admin',
    logout: 'Salir', start: 'Iniciar', stop: 'Parar', buy: 'COMPRAR', sell: 'VENDER',
    balance: 'Balance', paper: 'Saldo ficticio', real: 'Saldo real',
    connect_exchange: 'Conectar Exchange', my_bots: 'Mis Bots',
    create_bot: 'Crear Bot', profit: 'Ganancia', loss: 'Pérdida',
    win_rate: 'Tasa de acierto', language: 'Idioma',
  },
  en: {
    dashboard: 'Dashboard', bots: 'Bots', trading: 'Trading', arbitrage: 'Arbitrage',
    news: 'News', live: 'Live Data', settings: 'Settings', admin: 'Admin',
    logout: 'Logout', start: 'Start', stop: 'Stop', buy: 'BUY', sell: 'SELL',
    balance: 'Balance', paper: 'Paper balance', real: 'Real balance',
    connect_exchange: 'Connect Exchange', my_bots: 'My Bots',
    create_bot: 'Create Bot', profit: 'Profit', loss: 'Loss',
    win_rate: 'Win rate', language: 'Language',
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('aegis_lang') || 'es');
  const change = (l) => { setLang(l); localStorage.setItem('aegis_lang', l); };
  const t = (key) => (DICT[lang] && DICT[lang][key]) || DICT.es[key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang: change, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
